<template>
    <div class="actuele-dekkingsgraad">
        <p>Er dreigen kortingen als de actuele dekkingsgraad onder de 90% ligt.
            <span v-if="fonds && fonds.actueledekkingsgraad">Bij {{fondsNaam}} is de actuele dekkingsgraad op dit moment
                {{fonds.actueledekkingsgraad | formatNumber}}%.</span>
            <span v-else>Van {{fondsNaam}} is de actuele dekkingsgraad bij ons niet bekend.</span>
        </p>
    </div>
</template>

<script>
    export default {
        name: "ActueleDekkingsgraad",
        props: {
            fonds: Object
        },
        computed: {
            fondsNaam() {
                return this.fonds ? this.fonds.fonds : '';
            }
        }
    }
</script>

<style scoped>

</style>
